module.exports = __webpack_public_path__ + "media/assets/PrizeStar-2a939b40a6b859a66b4669ed3d4e95ee.svg";